import React from "react"
import { getBrandLogoScaleStyle } from "./brand-logo-scales"

const BrandLogoImg = ({ src, alt = "", context, brand, style, ...rest }) => (
  <img
    src={src}
    alt={alt}
    decoding="async"
    {...rest}
    style={{ ...style, ...getBrandLogoScaleStyle(src, context, brand) }}
  />
)

export default React.memo(BrandLogoImg)
